<template>
  <div>
    <template>
      <div>
        <!-- <app-add-matter-notes :matter="matter" :user="user"></app-add-matter-notes> -->
      </div>
    </template>
    <div>
      <!-- <v-btn color="red" small @click="deleteActivities">DELETE ALL</v-btn> -->
      <v-expand-transition
        v-for="(activity, index) in matter.activities"
        :key="index"
      >
        <!-- <v-expand-transition v-for="(note, index) in reversedNotes" :key="index"> -->
        <!-- <v-expand-transition v-for="(note, index) in matter.notes.slice().reverse()" :key="index"> -->

        <v-card
          style="border: 2px solid black"
          class="ma-2 white--text font-weight-light"
          outlined
          shaped
        >
          <v-row>
            <v-flex>
              <v-card-text
                class="subtitle black--text font-weight-light text-justify ma-auto"
                style="border-radius: 26px"
                >{{ activity.content }}
                <div
                  class="blue--text font-weight-light text-justify ml-4"
                  style="border-radius: 26px"
                  v-if="activity.user.email"
                >
                  -- {{ activity.user.email }}
                </div>
                <div
                  class="blue--text font-weight-light text-justify ml-4"
                  style="border-radius: 26px"
                  v-if="activity.user.username"
                >
                  -- {{ activity.user.username }}
                </div>
                <div
                  class="red--text font-weight-light text-justify ml-4"
                  style="border-radius: 26px"
                >
                  -- {{ activity.date }}
                </div>
              </v-card-text>
            </v-flex>
            <v-spacer></v-spacer>
            <!-- <v-flex> -->
            <!-- <v-btn
              class="ma-1"
              text
              
              rounded
              outlined
              color="yellow"
              @click="selectParty(plaintiff)"
          >select</v-btn>-->
          </v-row>
        </v-card>
      </v-expand-transition>
    </div>
  </div>
  <!-- <div>HELLO</div> -->
  <!-- </div> -->
</template>

<script>
/**
 *
 * this component shows the activities of a matter
 * the activities are reversed and shown to the user
 * this component needs to be tested to make sure it works properly in real time
 *
 */
import firebase from "firebase";
// import * as moment from "moment";
export default {
  // props: ["matter", "user"],
  props: ["user"],
  data() {
    return {
      dialog: false,
      reversedActivities: []
      // replyContent: null,
      // noteIndex: null,

      // plaintiffs: this.matter.plaintiffs
      // selectedPlaintiffs: []
      // notes: []
    };
  },
  watch: {
    matter(val) {
      console.log("matter changed", val);
      if (val.activities !== null && val.activities !== undefined) {
        let array = this.matter.activities.slice().reverse();
        // let reversedArray = array.reverse();
        // let reversedArray = this.matter.notes.slice().reverse();

        // return reversedArray;
        this.reversedActivities = array;
        // return array;
      }
    }
  },
  computed: {
    // reversedActivities() {
    //   if (this.matter.activities !== null && this.matter.activities !== undefined) {
    //     let array = this.matter.notes.slice().reverse();
    //     // let reversedArray = array.reverse();
    //     // let reversedArray = this.matter.notes.slice().reverse();

    //     // return reversedArray;
    //     return array;
    //   } else {
    //     return null;
    //   }
    // },
    matter() {
      return this.$store.getters.getMatter(this.$route.params.id);
    }
  },
  methods: {
    deleteActivities() {
      alert(
        "are you sure you want to permanently delete ALL the activities that have been logged in this matter? "
      );
      firebase
        .firestore()
        .collection("matters")
        .doc(this.matter.matterSlug)
        .update({
          activities: []
        })
        .then(() => {
          console.log("successfully deleted activities");
        });
    }

    // openDialog(index) {
    //   console.log(index);
    //   this.noteIndex = index;
    // },
    // deleteReply(i, index) {
    //   // let array = this.matter.notes.slice().reverse();
    //   let replyToDelete = this.matter.notes[index].replies[i];
    //   // let replyToDelete = array[index].replies[i];
    //   if (replyToDelete.user.email === this.user.email) {
    //     //   firebase
    //     //     .firestore()
    //     //     .collection("firms")
    //     //     .doc(this.user.firmSlug)
    //     //     .collection("matters")
    //     //     .doc(this.matter.matterSlug)
    //     //     .collection("notes")
    //     //     .doc(note.id)
    //     //     .delete()
    //     //     .then(() => {
    //     //       //add this to activities
    //     //       console.log("deleted note");
    //     //     })
    //     //     .catch(e => console.error(e));
    //     // }
    //     let newNoteList = Array.from(this.matter.notes);
    //     newNoteList[index].replys.splice(1, i);
    //     console.log(newNoteList);
    //     firebase
    //       .firestore()
    //       .collection("firms")
    //       .doc(this.user.firmSlug)
    //       .collection("matters")
    //       .doc(this.matter.matterSlug)
    //       .update({
    //         notes: newNoteList
    //       })
    //       .then(() => {
    //         console.log("deleted note reply");
    //       })
    //       .catch(e => {
    //         console.error(e);
    //       });
    //   }
    // },
    // replyToNote() {
    //   console.log("this.noteIndex", this.noteIndex);
    //   if (this.replyContent !== null && this.replyContent !== undefined) {
    //     let reply = {
    //       content: this.replyContent,
    //       date: moment().format("MMMM Do YYYY, h:mm:ss a"),
    //       user: this.user,
    //       // tags: this.tags,
    //       replies: []
    //     };
    //     //   // let array = this.matter.notes.slice().reverse();
    //     let noteWithReply = this.matter.notes[this.noteIndex];
    //     //   // let noteWithReply = array.notes[index];
    //     //   // if (noteWithReply.replies) {
    //     //   noteWithReply.replies.push(reply);
    //     //   // } else {
    //     //   // noteWithReply.replies = [];
    //     noteWithReply.replies.push(reply);
    //     //   // }
    //     console.log("noteWithReply", noteWithReply);
    //     let newNoteList = Array.from(this.matter.notes);
    //     //   console.log(newNoteList);
    //     newNoteList.splice(this.noteIndex, 1, noteWithReply);
    //     console.log(newNoteList);
    //     firebase
    //       .firestore()
    //       .collection("firms")
    //       .doc(this.user.firmSlug)
    //       .collection("matters")
    //       .doc(this.matter.matterSlug)
    //       .update({
    //         notes: newNoteList
    //       })
    //       .then(() => {
    //         console.log("added note ");
    //         this.replyContent = null;
    //         this.dialog = false;
    //       })
    //       .catch(e => {
    //         console.error(e);
    //       });
    //     //   // this.replyContent = null;
    //     //   // this.dialog = false;
    //   }
    // },
    // deleteNote(note) {
    //   // let newArray = Array.from(this.matter.plaintiffs);
    //   // //remove the doc from the array
    //   // newArray.splice(index, 1);
    //   // console.log("newArray", newArray);
    //   // console.log("oldArray", this.matter.plaintiffs);
    //   if (note.user.email === this.user.email) {
    //     //   firebase
    //     //     .firestore()
    //     //     .collection("firms")
    //     //     .doc(this.user.firmSlug)
    //     //     .collection("matters")
    //     //     .doc(this.matter.matterSlug)
    //     //     .collection("notes")
    //     //     .doc(note.id)
    //     //     .delete()
    //     //     .then(() => {
    //     //       //add this to activities
    //     //       console.log("deleted note");
    //     //     })
    //     //     .catch(e => console.error(e));
    //     // }
    //     firebase
    //       .firestore()
    //       .collection("firms")
    //       .doc(this.user.firmSlug)
    //       .collection("matters")
    //       .doc(this.matter.matterSlug)
    //       .update({
    //         notes: firebase.firestore.FieldValue.arrayRemove(note)
    //       })
    //       .then(() => {
    //         console.log("deleted note ");
    //       })
    //       .catch(e => {
    //         console.error(e);
    //       });
    //   }
    // }
    // created() {
    // let notesRef = firebase
    //   .firestore()
    //   .collection("firms")
    //   .doc(this.user.firmSlug)
    //   .collection("matters")
    //   .doc(this.matter.matterSlug)
    //   .collection("notes");
    // notesRef.onSnapshot(res => {
    //   const changes = res.docChanges();
    //   changes.forEach(change => {
    //     if (change.type === "added") {
    //       const addedNote = change.doc.data();
    //       const existingNote = this.notes.find(
    //         note => note.id === addedNote.id
    //       );
    //       if (existingNote !== null && existingNote !== undefined) {
    //         console.log("added note already in list", addedNote);
    //         return;
    //       } else {
    //         this.notes.push(addedNote);
    //         console.log("added note", addedNote);
    //       }
    //     } else if (change.type === "modified") {
    //       const modifiedNote = change.doc.data();
    //       console.log("modified note: ", modifiedNote);
    //       const existingNote = this.notes.find(
    //         note => note.id === modifiedNote.id
    //       );
    //       if (existingNote !== null && existingNote !== undefined) {
    //         console.log("note already in list: replacing it now", existingNote);
    //         //find the index of existing client
    //         let index = this.notes.indexOf(existingNote);
    //         this.notes.splice(index, 1, modifiedNote);
    //       } else {
    //         this.notes.push(modifiedNote);
    //         console.log("added note", modifiedNote);
    //       }
    //     } else if (change.type === "removed") {
    //       const removedNote = change.doc.data();
    //       console.log("note being removed", removedNote);
    //       const existingNote = this.notes.find(note => note.id === note.id);
    //       const index = this.notes.indexOf(existingNote);
    //       this.notes.splice(index, 1);
    //     }
    //   });
    // });
  }
};
</script>

<style lang="scss" scoped></style>
